import { setAlertMessage } from "state/slices/alertSlice";
import { setLoginStatus } from "state/slices/loginSlice";
import { setLoginView } from "state/slices/loginViewSlice";
import { setRole } from "state/slices/roleSlice";
import { clearUsername, setUsername } from "state/slices/userSlice";

const { default: callApi } = require("./api");

const validateToken = async (navigate, dispatch, activeRoute) => {
  var response = await callApi(
    `/validate`,
    "GET",
    null,
    false,
    true,
    dispatch,
    navigate
  );
  if (response?.success) {
    const body = response?.body?.body;
    dispatch(setUsername(body?.username));
    dispatch(setRole(body?.role));
    dispatch(setLoginStatus(true));
    const role = body?.role;
    localStorage.setItem("role", role);
    if (
      body?.hasPasswordChanged === null ||
      body?.hasPasswordChanged === false ||
      body?.hasPasswordChanged === "false"
    ) {
      dispatch(setLoginView("change-password"));
      navigate("/change-password");
      return;
    }
    if (activeRoute === "/") {
      if ("Admin" === role) {
        navigate("/dashboard");
      } else if ("Police".match(role)) {
        navigate("/dashboard");
      } else if ("Advocate" === role) {
        navigate("/dashboard");
      } else {
        localStorage.clear();
        dispatch(setLoginStatus(false));
        dispatch(clearUsername());
        dispatch(setAlertMessage("You do not have access to this portal."));
        dispatch(setLoginView("login"));
        navigate("/");
      }
    }
  } else {
    localStorage.clear();
    dispatch(setLoginStatus(false));
    dispatch(clearUsername());
  }
};

export default validateToken;
